import axios from 'axios'

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_ROBOT_BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})

export default apiClient